import React from "react";
import { Helmet } from "react-helmet";
// import "../../style/general-class.css";
import { ChevronRight, EmojiSmile, JournalAlbum, People, Cpu } from "react-bootstrap-icons";
import { motion } from "framer-motion";
import "./About.css";
import Navbar from "../../Hooks/Navbar/Navbar";
import usestyle from "../../Hooks/style/usestyle";

const About = () => {
  const { variant, variantProgress } = usestyle();
  return (
    <>
      <Helmet>
        <title>About Mohammad Nour Khattab - Professional Background & Skills</title>
        <meta
          name="description"
          content="Learn more about Mohammad Nour Khattab's professional journey, skills, and expertise in Full Stack Development. Over 5 years of experience in building web and mobile applications."
        />
        <meta
          name="keywords"
          content="About Mohammad Nour Khattab, Full Stack Developer Experience, Web Development Skills, Technical Expertise, Developer Portfolio"
        />
        <link rel="canonical" href="https://nour-it.dev/about" />
      </Helmet>
      <Navbar />
      {/* <motion.div
        initial={{ y: -1500 }}
        animate={{ y: 0 }}
        exit={{ x: "100vw", transition: { duration: 0.2 } }}
        transition={{ duration: 0.2, ease: "easeInOut", type: "spring", stiffness: "120" }}
        className="about page"
      > */}

      <motion.div
        variants={variant}
        initial="initial"
        animate="animate"
        exit="exit"
        // transition="transition"
        className="about page"
      >
        <div className="contener">
          <span className="span-line">ABOUT</span>
          <div className="big-header">LEARN MORE ABOUT ME </div>
          {/* <a
            href="https://docs.google.com/document/d/15SOBDct9RBsIrk9iDbp3ngMIW2GUlnHW0h7QXPw9f1g/edit?usp=sharing"
            title="visit my CV"
            target="_blank"
            rel="noopener noreferrer"
          >
            Click to visit My CV
          </a> */}
          <div className=" personal wrap">
            <div className="img">
              <img src="./img/me3.jpg" alt="me" />
            </div>
            <div className="content ">
              <div className="mid-header">
                Full Stack Developer <br />
                <p className="desc">
                  I'm a Full Stack Developer with over 5 years of hands-on experience building web and mobile
                  applications using a wide range of technologies.
                  <br />
                  <br />I specialize in creating fast, scalable, and user-friendly interfaces using tools like{" "}
                  <strong>React.js</strong>, <strong>React Native</strong>, <strong>Next.js</strong>, and{" "}
                  <strong>Remix.js</strong>, along with backend frameworks like <strong>Express.js</strong>,{" "}
                  <strong>Node.js</strong>, <strong>Laravel</strong>, and <strong>Django</strong>. I work comfortably
                  with both SQL (<strong>MySQL</strong>, <strong>PostgreSQL</strong>) and NoSQL (
                  <strong>MongoDB</strong>), and I often integrate <strong>Strapi</strong> or other headless CMS
                  solutions.
                  <br />
                  <br />
                  Throughout my career, I’ve contributed to complex dashboards, mobile apps (Android & iOS), and ERP
                  systems. I’m also experienced in <strong>project management</strong>,{" "}
                  <strong>API integrations</strong>, <strong>authentication & security (JWT, Auth0, RBAC)</strong>, and{" "}
                  <strong>performance optimization</strong>. Whether it’s frontend, backend, or DevOps — I love
                  delivering clean, efficient, and maintainable code.
                  <br />
                </p>
              </div>
              <div className="flex">
                <p>
                  <ChevronRight className="icon" /> <span>Birthday : </span> 1 Jan 1993
                </p>
                <p>
                  <ChevronRight /> <span>Age : </span> 32
                </p>
                <p>
                  <ChevronRight /> <span>Website : </span>
                  <a href="https://nour-it.dev/" title="visit website" target="_blank" rel="noopener noreferrer">
                    {" "}
                    nour-it.dev{" "}
                  </a>
                </p>
                <p>
                  <ChevronRight /> <span>Degree : </span> Bachelor
                </p>
                <p>
                  <ChevronRight /> <span>Phone : </span>
                  <a href="tel:+971547809856"> +971 54 780 9856 </a>{" "}
                </p>
                <p>
                  <ChevronRight /> <span>Email : </span>
                  <a
                    href="mailto: m.nour.kh9346@gmail.com"
                    title="Send Email"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    m.nour.kh9346@gmail.com
                  </a>
                </p>
                <p>
                  <ChevronRight /> <span>City : </span> Dubai UAE
                </p>
                <p>
                  <ChevronRight /> <span>Freelance : </span> Available
                </p>
              </div>
              <div className="footer">
                Right now, I’m expanding my expertise into areas I believe will define the next era of development.
                <br />
                <br />
                I’m actively learning <strong>Artificial Intelligence</strong> through specialized programs at{" "}
                <strong>Udacity</strong> and <strong>Coursera</strong>, with a strong focus on{" "}
                <strong>AI integration</strong> within web and mobile applications. My goal is to build smarter, more
                dynamic experiences powered by AI.
                <br />
                <br />
                In parallel, I’m diving into <strong>Microservices Architecture</strong> to better structure large-scale
                systems with flexibility and scalability in mind.
                <br />
                <br />
                Current focus areas include AI + web integration, microservices, and cloud deployments.
                <br />
                <br />I see the future of development as deeply collaborative, distributed, and intelligent — and I’m
                here to be part of it.
              </div>
            </div>
          </div>
          <div className="counters">
            <div>
              <EmojiSmile className="icon" />
              <span>+50</span>
              <span> Happy Clients</span>
            </div>
            <div>
              <JournalAlbum className="icon" />
              <span>+99</span>
              <span> Projects</span>
            </div>
            <div>
              <Cpu className="icon" />
              <span>+20</span>
              <span>Technologies Used</span>
            </div>
            <div>
              <People className="icon" />
              <span>+12</span>
              <span>Team Projects</span>
            </div>
          </div>
          {/* end Personal */}
          <div className="skills">
            <span className="span-line">SKILLS</span>
            <div className="skills-con">
              {/* Frontend & Languages */}
              <div className="left">
                <div className="skill">
                  <div className="head">
                    <span>HTML & CSS</span>
                    <span>100%</span>
                  </div>
                  <motion.div
                    variants={variantProgress}
                    initial="hidden"
                    animate="visible"
                    custom="100%"
                    className="bar"
                  />
                </div>
                <div className="skill">
                  <div className="head">
                    <span>JavaScript</span>
                    <span>95%</span>
                  </div>
                  <motion.div
                    variants={variantProgress}
                    initial="hidden"
                    animate="visible"
                    custom="95%"
                    className="bar"
                  />
                </div>
                <div className="skill">
                  <div className="head">
                    <span>React.js</span>
                    <span>90%</span>
                  </div>
                  <motion.div
                    variants={variantProgress}
                    initial="hidden"
                    animate="visible"
                    custom="90%"
                    className="bar"
                  />
                </div>
                <div className="skill">
                  <div className="head">
                    <span>Next.js</span>
                    <span>85%</span>
                  </div>
                  <motion.div
                    variants={variantProgress}
                    initial="hidden"
                    animate="visible"
                    custom="85%"
                    className="bar"
                  />
                </div>
                <div className="skill">
                  <div className="head">
                    <span>PHP & Laravel</span>
                    <span>75%</span>
                  </div>
                  <motion.div
                    variants={variantProgress}
                    initial="hidden"
                    animate="visible"
                    custom="75%"
                    className="bar"
                  />
                </div>
                <div className="skill">
                  <div className="head">
                    <span>Python & Django</span>
                    <span>70%</span>
                  </div>
                  <motion.div
                    variants={variantProgress}
                    initial="hidden"
                    animate="visible"
                    custom="70%"
                    className="bar"
                  />
                </div>
              </div>

              {/* Backend & Databases */}
              <div className="right">
                <div className="skill">
                  <div className="head">
                    <span>Express.js & Fastify</span>
                    <span>85%</span>
                  </div>
                  <motion.div
                    variants={variantProgress}
                    initial="hidden"
                    animate="visible"
                    custom="85%"
                    className="bar"
                  />
                </div>
                <div className="skill">
                  <div className="head">
                    <span>MongoDB (NoSQL)</span>
                    <span>75%</span>
                  </div>
                  <motion.div
                    variants={variantProgress}
                    initial="hidden"
                    animate="visible"
                    custom="75%"
                    className="bar"
                  />
                </div>
                <div className="skill">
                  <div className="head">
                    <span>SQL / PostgreSQL</span>
                    <span>70%</span>
                  </div>
                  <motion.div
                    variants={variantProgress}
                    initial="hidden"
                    animate="visible"
                    custom="70%"
                    className="bar"
                  />
                </div>
                <div className="skill">
                  <div className="head">
                    <span>DevOps (Docker, AWS, Cloudflare)</span>
                    <span>60%</span>
                  </div>
                  <motion.div
                    variants={variantProgress}
                    initial="hidden"
                    animate="visible"
                    custom="60%"
                    className="bar"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default About;
